import React, { useEffect } from 'react'
import useModal from '../../hooks/useModal'
import CrossSVG from '../custom-ui/icons/CrossSVG'

import CreateEventForm from './Component/CreateEventForm'
import ToastAlert from '../custom-ui/toast-alert/ToastAlert'
import { createPortal } from 'react-dom'

const CreateEvent = () => {
    const { isShowing, toggle }: any = useModal()

    // 🔒 Disable background scroll
    useEffect(() => {
        document.body.style.overflow = isShowing ? 'hidden' : ''
        return () => {
            document.body.style.overflow = ''
        }
    }, [isShowing])

    return (
        <>
            <button
                onClick={toggle}
                className="text-white px-6 py-[6px] bg-instant-teams-blue-Main"
            >
                Create New Event
            </button>

            {isShowing &&
                createPortal(
                    <div
                        className="fixed top-0 left-0 w-screen h-screen bg-gray-900/60 z-[9999]
                 flex items-center justify-center"
                        onClick={toggle}
                    >
                        <div
                            className="relative bg-white rounded-lg shadow-xl
                   w-[50%] max-h-[90vh] overflow-y-auto"
                            onClick={(e) => e.stopPropagation()}
                        >
                            {/* Close button */}
                            <div className="flex justify-end p-4">
                                <button
                                    className="w-[48px] h-[48px] rounded-full bg-[#F8F9FA]
                       text-[#183852] hover:bg-slate-200
                       flex items-center justify-center"
                                    onClick={toggle}
                                >
                                    <CrossSVG />
                                </button>
                            </div>

                            {/* Content */}
                            <div className="px-6 pb-6">
                                <CreateEventForm toggleModal={toggle} />
                            </div>
                        </div>
                    </div>,
                    document.body
                )
            }


            <ToastAlert />
        </>
    )
}

export default CreateEvent
